<template>
    <div class="uk-panel uk-panel-box" ref="moex-wrapper">
        <div id="moex-tile-link" style="margin-top: -110px; float: left;"></div>
		<h3 class="uk-panel-title">
            <i class="uk-icon-line-chart"></i>
            <span data-include-text="добавлена" data-exclude-text="исключена">Котировки акций</span>
        </h3>
        <div>
            <p style="font-weight:700; color:black; margin: 0">Цена на {{ current_price ? new Date(current_price[7]).toLocaleDateString() : "сегодня"}}</p>
            <h4 v-if="current_price && main_share" class="moex-security-name">
                <b>${{main_share.secid}}, </b>
                <span>{{current_price[1]}}</span> <i class="uk-icon-rub"></i> 
                <i v-if="main_share.type == 'preferred_share'">(акция превилигированная)</i>
                <i v-else-if="main_share.type == 'common_share'">(акция обыкновенная)</i>
            </h4>
            <div v-if="current_price" style="font-size: 12px; margin: 5px 0">
                <span>Откр. {{current_price[0]}}</span>,
                <span>Закр. {{current_price[1]}}</span>,
                <span>Выс. {{current_price[2]}}</span>,
                <span>Низ. {{current_price[3]}}</span>,
                <span>Обьем. {{Math.floor(current_price[4])}}</span>
                <span><i class="uk-icon-rub"></i></span>
            </div>
            <!-- <div>
                <button>D</button>
                <button>W</button>
                <button>M</button>
            </div> -->
        </div>
        <div style="position: relative;">
            <div class="dib vat moex-chart" ref="moex-chart"></div>
            <div class="moex-chart-tooltip" v-if="tooltip_open + tooltip_close + tooltip_high + tooltip_low" ref="moex-chart-tooltip" :style="{ left: `${tooltipLeft}px` }">
                <span class="moex-chart-tooltip__price">Откр: {{tooltip_open}} <i class="uk-icon-rub"></i></span>
                <span class="moex-chart-tooltip__price">Закр: {{tooltip_close}} <i class="uk-icon-rub"></i></span>
                <span class="moex-chart-tooltip__price">Выс: {{tooltip_high}} <i class="uk-icon-rub"></i></span>
                <span class="moex-chart-tooltip__price">Низ: {{tooltip_low}} <i class="uk-icon-rub"></i></span>
                <span v-if="tooltip_time" class="moex-chart-tooltip__time">{{tooltip_time.day}}.{{tooltip_time.month}}.{{tooltip_time.year}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { createChart } from 'lightweight-charts';
import { detectIEEdge } from '@/helpers.ts'

export default {
    data(){
        return {
            securities: [],
            candles: [],
            tooltip_open: 0,
            tooltip_close: 0,
            tooltip_high: 0,
            tooltip_low: 0,
            tooltip_time: 0,
            tooltipLeft: 0
        }
    },
    computed: {
        common_shares(){
            return this.securities.filter(e => e.type == "common_share")
        },
        preferred_shares(){
            return this.securities.filter(e => e.type == "preferred_share")
        },
        main_share(){
            if(this.common_shares && this.common_shares.length) {
                return this.common_shares[0]
            } else if(this.preferred_shares && this.preferred_shares.length) {
                return this.preferred_shares[0]
            }
        },
        current_price(){
            if(this.candles.length) {
                return this.candles.reverse()[0]
            }
        }
    },
    async mounted(){
        if(!detectIEEdge()) {
            await this.getSecurities()
            try {
                await this.getCandles()
            } catch(err) {
                console.log('this.getCandles()', err)
            }
        } else {
            this.hideTile()
        }
    },
    methods: {
        hideTile(){
            $("#moex-tile").hide()
            $('#tiles').trigger('resize')
            sidebar.checkTilesState()
        },
        getCandles(engine = "stock", market = "shares"){
            if(this.main_share) {
                const { secid } = this.main_share
                
                console.log("COMPUTED STYLE",window.getComputedStyle(this.$refs['moex-wrapper']))

                const tileWidth = parseInt(window.getComputedStyle(this.$refs['moex-wrapper']).width) - 50

                const chart = createChart(this.$refs['moex-chart'], {
                    height: 400,
                    width: tileWidth
                })
                
                const candlestickSeries = chart.addCandlestickSeries()

                chart.subscribeCrosshairMove(e => {
                    const candleSeriesHoverData = e.seriesPrices.get(candlestickSeries)
                    
                    if(e.time) {
                        this.tooltip_time = e.time
                    }
                    
                    if(candleSeriesHoverData) {
                        this.tooltip_open = candleSeriesHoverData.open
                        this.tooltip_close = candleSeriesHoverData.close
                        this.tooltip_high = candleSeriesHoverData.high
                        this.tooltip_low = candleSeriesHoverData.low
                    } else {
                        this.tooltip_open = 0
                        this.tooltip_close = 0
                        this.tooltip_high = 0
                        this.tooltip_low = 0
                        this.tooltip_time = 0
                    }

                    if(e.point && e.point.x && this.$refs['moex-chart-tooltip'] && window.getComputedStyle(this.$refs['moex-chart-tooltip'])){
                        this.tooltipLeft = Math.floor(e.point.x) - (parseInt(window.getComputedStyle(this.$refs['moex-chart-tooltip']).width) / 2)
                    }
                })
                const fiveHundredDaysBack = new Date(new Date().setDate(new Date().getDate() - 499))
                const year = fiveHundredDaysBack.getFullYear()
                const month = ("0" + (fiveHundredDaysBack.getMonth() + 1)).slice(-2)
                const day = ("0" + fiveHundredDaysBack.getDate()).slice(-2)
                return axios({
                    method: "get",
                    url: `https://iss.moex.com/iss/engines/${engine}/markets/${market}/securities/${secid}/candles.json?interval=24&from=${year}-${month}-${day}`,
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(e => {
                    if(e.data?.candles?.data?.length) {
                        
                        this.candles = e.data.candles.data

                        const formatted_candles = e.data.candles.data.map(e=>({
                            open: e[0],
                            close: e[1],
                            high: e[2],
                            low: e[3],
                            time: {
                                day: new Date(e[6]).getDate(),
                                month: new Date(e[6]).getMonth(),
                                year: new Date(e[6]).getFullYear()
                            },
                        }))

                        candlestickSeries.setData(formatted_candles)
                    } else {
                        this.hideTile()
                    }
                })
            } else {
                this.hideTile()
            }
        },
        getSecurities(){
            console.log('getSecid')
            if(window.company && window.company.inn) {
                return axios({
                    method: 'get',
                    url: `https://iss.moex.com/iss/securities.json?q=${window.company.inn}`,
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(e => {
                    if(e.data && e.data.securities && e.data.securities.data && e.data.securities.data.length){
                        this.securities = e.data.securities.data.map(e => ({
                            id: e[0],
                            secid: e[1],
                            shortname: e[2],
                            regnumber: e[3],
                            name: e[4],
                            isin: e[5],
                            is_traded: e[6],
                            emitent_id: e[7],
                            emitent_title: e[8],
                            emitent_inn: e[9],
                            emitent_okpo: e[10],
                            gosreg: e[11],
                            type: e[12],
                            group: e[13],
                            primary_boardid: e[14],
                            marketprice_boardid: e[15]
                        }))
                    } else {
                        this.hideTile()
                    }
                })
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

.moex-security-name
    span
        font-size: 26px
    i
        font-size: 12px
        display: block

.moex-chart-tooltip
    z-index: 1
    position: absolute
    top: 0
    left: 0
    height: 100%
    background-color: rgba(0, 0, 150, 0.1)
    padding: 5px
    min-width: 100px
    span
        display: block
        width: 100%
        &.moex-chart-tooltip__price
            font-size: 14px
            font-weight: bold
        &.moex-chart-tooltip__time
            font-size: 12px

.moex-securities-panel
    height: 300px
    overflow-y: scroll
    width: 170px
    padding-left: 5px
    font-size: 14px
    ul
        padding: 0
        margin-top: 5px
        li
            cursor: pointer
            &:hover
                color: $link-blue-color
</style>